import departments, {
	DepartmentIds
} from '../../../../shared/common/values/departments'
import { UpgradeTypes } from '../../../../shared/common/values/upgrades/enums'
import type { Upgrade } from '../../../../shared/types/Upgrade'
import { formatBigInt } from '../../common/format_large_number'

function forToHumanReadable(affects: DepartmentIds[]) {
	switch (affects.length) {
		case 1:
			return departments[affects[0]].name
		case 2:
			return `${departments[affects[0]].name} and ${departments[affects[1]].name}`
		default: {
			const last = affects.pop()
			if (typeof last === 'undefined') return ''
			return `${affects.map((id) => departments[id].name).join(', ')}, and ${departments[last].name}`
		}
	}
}

export default function Upgrade({
	onClick,
	contents
}: {
	onClick: () => void
	contents: Upgrade
}) {
	// TODO: Customise the button based off contents. Connect to a png resource
	return (
		<button
			onClick={onClick}
			className="mb-4 w-full overflow-hidden rounded-2xl border border-purple-800 bg-purple-950 p-4 text-left backdrop-blur-sm transition-all hover:border-purple-700 hover:bg-purple-900"
		>
			<div className="mb-2 flex items-center justify-between">
				<h2 className="text-xl font-bold text-purple-100">{contents.name}</h2>
				<span className="rounded-full bg-purple-700 px-3 py-1 text-sm text-purple-100">
					${formatBigInt(BigInt(contents.cost))}
				</span>
			</div>
			<p className="mb-3 text-sm text-purple-200">{contents.description}</p>
			<hr className="my-3 border-0 border-t border-purple-600/50" />
			<ul className="space-y-2">
				{contents.effects.map((effect) => {
					const humanReadables = []
					for (const result of effect.results)
						switch (result) {
							case UpgradeTypes.TwoExponentRise:
								humanReadables.push(
									`Doubles ${forToHumanReadable(effect.for)} debt per second`
								)
								break
						}

					return humanReadables.map((humanReadable) => (
						<li
							key={effect.results.toString()}
							className="text-sm text-purple-300"
						>
							{humanReadable}
						</li>
					))
				})}
			</ul>
		</button>
	)
}
